import { render, staticRenderFns } from "./CountdownWidget.vue?vue&type=template&id=c1c45e90&scoped=true"
import script from "./CountdownWidget.vue?vue&type=script&lang=js"
export * from "./CountdownWidget.vue?vue&type=script&lang=js"
import style0 from "./CountdownWidget.vue?vue&type=style&index=0&id=c1c45e90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c45e90",
  null
  
)

export default component.exports